import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { RECORDING_STATUS } from "../../../utils/constants";
import { MediaCaptureContext } from "../../context/MediaCaptureContext";
import "./MediaComponent.css";
import { ReactComponent as Resume } from "../../../assets/media_icons/resume.svg";
import { ReactComponent as Pause } from "../../../assets/media_icons/pause.svg";
import { ReactComponent as Checkmark } from "../../../assets/media_icons/checkmark.svg";
import { ReactComponent as Microphone } from "../../../assets/media_icons/microphone.svg";
import MediaButton from "../MediaButton/MediaButton";
import MediaPlayer from "../MediaPlater/MediaPlayer";
import { calculateTime } from "../../../utils/mediaUtils";
import { useMediaRecorder } from "./useMediaRecorder";
import icoCheck from '../../../assets/ico-check.svg';

import popSound from "../../../assets/audios/pop.mp3";
import { useTimeLimitRecorder } from "./useTimeLimitRecorder";


export const AudioRecorderComponent = ({
  timer = 0, // in seconds
  submitDisabled = false,
  onConfirmAudio = () => { },
  isSendData = false
}) => {
  const {
    recordingStatus,
    mediaUrl,
    mediaBlob,
    startRecording,
    stopRecording,
    discardRecording,
  } = useContext(MediaCaptureContext);

  const audioRef = useRef();

  const {
    isPlaying,
    time,
    setTime,
    seekProgress,
    maxValue,
    setMaxValue,
    handleMediaTimeUpdated,
    handleStartRecording,
    handleTogglePause,
    handleDiscardMedia,
    handleSeek,
    handleEnded,
  } = useMediaRecorder({
    mediaRef: audioRef,
    mediaUrl,
    startRecording,
    discardRecording,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const playSound = () => {
    const sound = new Audio(popSound);
    sound.play();
  };

  useEffect(() => {
    if (!audioRef.current) {
      return;
    }
    const cacheAudioRef = audioRef.current;

    const handleLoadedMetadata = () => {
      if (audioRef.current.readyState > 0) {
        // FIXME: Firefox displays Infinity:NaN       
        setMaxValue(Math.ceil(audioRef.current.duration));
        setTime(calculateTime(audioRef.current.duration));
      }
    }

    cacheAudioRef.addEventListener('loadedmetadata', handleLoadedMetadata);

    return () => {
      if (cacheAudioRef) {
        cacheAudioRef.removeEventListener('loadedmetadata', handleLoadedMetadata);
      }
    }
  }, [setMaxValue, setTime])

  const handleConfirmDecision = useCallback(() => {
    if (!mediaUrlRef.current) return;
    cleanTimeout();

    playSound();
    setIsSubmitting(true); // Bloqueamos los botones
    onConfirmAudio(mediaUrlRef.current, mediaBlobRef.current);
  }, [onConfirmAudio]);

  const {
    mediaBlobRef,
    mediaUrlRef,
    cleanTimeout,
  } = useTimeLimitRecorder({
    mediaBlob,
    mediaUrl,
    timer,
    onConfirmSubmit: handleConfirmDecision,
  })

  return (
    <div className="media-question-container">
      {/* Preview */}
      <div className="media-confirmation-container">
        <MediaPlayer
          time={time}
          displayPlayButton={mediaUrl.length > 0 && !submitDisabled && recordingStatus !== RECORDING_STATUS.recording}
          isPlaying={isPlaying}
          onClickPlay={handleTogglePause}
          disabled={isSubmitting || !mediaUrl}
          displayDiscardButton={mediaUrl.length > 0 && !submitDisabled}
          progress={seekProgress}
          maxValue={maxValue}
          onClickDiscard={handleDiscardMedia}
          onChangeSeekBar={handleSeek}
        />
        <div className="media-player-action-buttons">
          <MediaButton
            pressed={recordingStatus === RECORDING_STATUS.recording || submitDisabled}
            disabled={recordingStatus === RECORDING_STATUS.recording || isSubmitting || submitDisabled}
            onClick={handleStartRecording}
          >
            <div className="media-record-thumb-container">
              <div className={`${recordingStatus === RECORDING_STATUS.recording ? "media-record-thumb-recording" : ""}`}>
                <Microphone height={40} width={40} className="media-icon media-icon-default" />
              </div>
            </div>
          </MediaButton>
          {recordingStatus === RECORDING_STATUS.recording &&
            <MediaButton onClick={stopRecording}>
              <Checkmark height={40} width={40} />
            </MediaButton>}
        </div>
        <button className="ConfirmButton"
          onClick={handleConfirmDecision}
          disabled={isSubmitting || !mediaUrl || submitDisabled}>
          <div className="principalBtn">
            {isSubmitting ? (isSendData ? "Enviado" : "Enviando...") : "Enviar"}
            {isSendData && <img className="sendCheck" src={icoCheck} alt="player ready" />}
          </div>
        </button>
      </div>

      {/* Recorded audio */}
      <audio ref={audioRef} onTimeUpdate={handleMediaTimeUpdated} onEnded={handleEnded}>
        {mediaUrl && (
          <source src={mediaUrl} type="audio/mp3" />)}
      </audio>
    </div>
  );
}

export default AudioRecorderComponent;